import { useAuth } from '../auth/AuthProvider'
import { SupplierCatalogPage } from '../components/SupplierCatalogPage'

export const RestaurantMyPricesScreen = () => {
  const { session } = useAuth()
  if (!session || session.organizationId == null) {
    return null
  }

  return (
    <SupplierCatalogPage
      organizationId={session.organizationId}
      importPath="/my-prices/import"
      catalogMode="restaurant-my-prices"
      title="Мои прайсы"
    />
  )
}
